import { MapPin } from 'lucide-react'

interface ZipInputProps {
  value: string
  setValue: (val: string) => void
  disabled?: boolean
  inputId?: string
  labelId?: string
  maxLength?: number
}

export function ZipInput(props: ZipInputProps) {
  const { value, setValue, disabled, inputId, labelId, maxLength } = props

  const maxLen = typeof maxLength === 'number' ? maxLength : 5

  return (
    <div className='flex-1 relative'>
      <div className='absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground'>
        <MapPin className='w-4 h-4' />
      </div>
      <label id={labelId} htmlFor={inputId} className='sr-only'>
        Enter zip code
      </label>
      <input
        id={inputId}
        type='text'
        name='zipText'
        value={value}
        autoComplete='off'
        autoCorrect='off'
        autoCapitalize='none'
        spellCheck={false}
        enterKeyHint='search'
        onChange={(e) => {
          const val = e.target.value
          const digitsOnly = val.replace(/\D/g, '')
          const limited = digitsOnly.slice(0, maxLen)
          setValue(limited)
        }}
        placeholder='Enter zip code'
        disabled={disabled}
        aria-labelledby={labelId}
        inputMode='numeric'
        pattern='[0-9]*'
        maxLength={maxLen}
        className='flex h-10 w-full items-center justify-between rounded-[var(--radius)] border border-[var(--color-input)] bg-[var(--color-background)] pl-10 pr-3 py-2 text-sm placeholder:text-[var(--color-muted-foreground)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-ring)] disabled:cursor-not-allowed disabled:opacity-50'
      />
      <input type='hidden' name='zipCode' value={value} />
    </div>
  )
}
